import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  sendGiftContainer: {
    minHeight: 835,
    padding: theme.spacing(24, 96, 20),
  },
}));
